import { useCallback, useMemo } from "react"
import { mutate } from "swr"
import { useApiData } from "./useApiData"
import { sendApiData } from "lib/api"
import { PaginatedResponse } from "models/PaginatedResponse"

export type NotificationType =
  | `New Designer Feedback`
  | `Contact Information Problem`
  | `Product Update Approved`
  | `Designer Profile Rejected`
  | `Product Update Rejected`
  | `Delivery Note Line Rejected`
  | `Order Item Allocated`
  | `Shopify Product Unlinked Unexpectedly`
  | `Designer Profile Approved`

export interface Notification {
  id: number
  notificationType: NotificationType
  message: string
  createdAt: string
  url: string
  requiresAction: boolean
}

export type NotificationListResponse = PaginatedResponse<Notification>

function useNotifications(page = 1) {
  const response = useApiData<NotificationListResponse>(
    `brands/notifications/?page=${page}`
  )

  const dismissNotification = useCallback(async (id: number) => {
    try {
      sendApiData(`brands/notifications/${id}/mark-as-read/`, {
        method: `POST`,
        retry: {
          limit: 3
        }
      })
    } catch {
      /* Empty */
    } finally {
      mutate(/brands\/notifications\//)
    }
  }, [])

  return useMemo(
    () => ({ ...response, dismissNotification }),
    [dismissNotification, response]
  )
}

export default useNotifications
